module.exports = __webpack_public_path__ + "9af33807f2d897d6cbd38eaaeb6ea964.fbx";